import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import React from 'react';

import { ticketTourOptionPropTypes } from './PropTypes';

import UpgradeCard from '../BookingFieldset/UpgradeCard';
import {
  currencyDepositAndTotalPricePropTypes,
  getPricePerPaxTypePerCurrency,
} from '../../../util/currency';

const propTypes = exact({
  currencyPriceSetting: currencyDepositAndTotalPricePropTypes,
  currencySymbol: PropTypes.string.isRequired,
  groupKey: PropTypes.string.isRequired,
  handleFieldSelect: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(ticketTourOptionPropTypes).isRequired,
  selectedKey: PropTypes.string.isRequired,
  selectedText: PropTypes.string,
  soldOutText: PropTypes.string.isRequired,
  perPersonText: PropTypes.string,
});

const defaultProps = {
  selectedText: '',
  perPersonText: 'pp',
};

function TicketGroup(props) {
  const {
    groupKey,
    handleFieldSelect,
    soldOutText,
    currencyPriceSetting,
    currencySymbol,
    perPersonText,
  } = props;

  return (
    <div className="UpgradeGroup">
      <div className="UpgradeGroup_itemGroup">
        {props.options.map((ticketTourOption) => {
          const currencyPriceSettingPrice = getPricePerPaxTypePerCurrency(
            ticketTourOption.pricePerPax[0].pricePerCurrency,
            currencyPriceSetting.currency
          );
          return (
            <div className="UpgradeGroup_item" key={ticketTourOption.key}>
              <UpgradeCard
                blockName="UpgradeGroup_card"
                currencySymbol={currencySymbol}
                description={ticketTourOption.option.fullDescription}
                handleClick={() => handleFieldSelect(groupKey, ticketTourOption.option.key)}
                isSelected={ticketTourOption.option.key === props.selectedKey}
                limitedAvailability={ticketTourOption.limitedAvailability}
                limitedAvailabilityText={ticketTourOption.limitedAvailabilityText}
                limitedAvailabilityRemainingSpaces={
                  ticketTourOption.limitedAvailabilityRemainingSpaces
                }
                limitedAvailabilityRemainingText={ticketTourOption.limitedAvailabilityText}
                perPersonText={perPersonText}
                price={currencyPriceSettingPrice}
                pricePerPerson
                selectedText={props.selectedText}
                title={ticketTourOption.option.title}
                soldOut={ticketTourOption.soldOut}
                soldOutText={soldOutText}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}

TicketGroup.defaultProps = defaultProps;
TicketGroup.propTypes = propTypes;

export default TicketGroup;
